function ContainerBox(props) {
    return (
        <div className="app-content d-flex justify-content-start align-items-start mt-5">
            <div className="d-block flex-fill container-default">
                <div className="pt-0 pt-md-4 w-100 mb-0">
                    <div className="row">
                        <div className="col-12">
                            {props.children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContainerBox;